<template>
  <div class="">
    <div class="flex w-full items-center justify-between">
      <div :class="titleClasses + ' cursor-pointer'" @click.prevent="showContent = !showContent">
        <span :class="showContent ? activeTitleClasses : ''">{{ title }}</span>
        <i class="fas fa-plus text-gray-500" v-show="!showContent"></i>
        <i class="fas fa-minus text-gray-500" v-show="showContent"></i>
      </div>
      <div class="">
        <slot name="right"></slot>
      </div>
    </div>
    <div class="py-2" v-show="showContent">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    titleClasses: {
      type: String,
      default: 'uppercase text-base font-bold py-2',
    },
    active: {
      type: Boolean,
      default: true,
    },
    activeTitleClasses: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showContent: !!this.active,
    }
  },
}
</script>
